import moment from 'moment'
import React, { ReactNode } from 'react'
import DateBar from '../../common/date/DateBar'
import withDate, { WithDateProps } from '../../common/date/withDate'
import { RestrictedProvider } from '../auth/RestrictedContext'
import withActiveStation, { WithActiveStationProps } from '../station/withActiveStation'
import css from './monthlyInfoPage.css'
import MonthlyInfoTaskTable from './MonthlyInfoTaskTable'
import type { NoteSectionType, SubjectType } from './monthlyInfoTypes'
import NoteSection from './NoteSection'

type MonthlyInfoPageChildrenProps = {
  subject: SubjectType
  date: string
  dateFormat: string
  onDateChange: (date: string) => void
  stationId: string
  salesIncentiveUnit: string
  companyId?: string
  currentMonth: string
}

type MonthlyInfoPageProps = {
  subject: SubjectType
  children: (props: MonthlyInfoPageChildrenProps) => ReactNode
}

@withDate({
  dateFormat: 'YYYY-MM',
  paramName: 'month',
})
@withActiveStation
class MonthlyInfoPage extends React.PureComponent<MonthlyInfoPageProps> {
  render() {
    const { subject, date, dateFormat, onDateChange, activeStation } = this.props as MonthlyInfoPageProps &
      WithActiveStationProps &
      WithDateProps
    const previousMonth = moment(date, dateFormat).subtract(1, 'month').format(dateFormat)
    return (
      <div className={css.component}>
        <RestrictedProvider requiredPermission='edit_weeklyInfo'>
          <DateBar
            dateUnit='month'
            {...{
              date,
              dateFormat,
              onDateChange,
            }}
          />
          {this.props.children({
            subject,
            date: previousMonth,
            dateFormat,
            onDateChange,
            stationId: activeStation.id,
            salesIncentiveUnit: activeStation.salesIncentiveUnit,
            companyId: activeStation.company?.id,
            currentMonth: date,
          })}
          <NoteSection
            section={subject === 'Management' ? 'General' : (subject as NoteSectionType)}
            date={moment(date).format('YYYY-MM-DD')}
            stationId={activeStation.id}
          />
          <div className={css.taskTable}>
            <MonthlyInfoTaskTable stationId={activeStation.id} month={previousMonth} subject={subject} />
          </div>
        </RestrictedProvider>
      </div>
    )
  }
}

export default MonthlyInfoPage
